<template>
  <div
    id="cart-flyout-drawer"
    class="drawer cart-flyout"
    data-cart-drawer
    role="dialog"
  >
    <div
      class="cart-flyout__inner quick-cart"
      data-quick-cart
    >
      <slot name="header" />
      <div
        v-show="!tabIsMinicart"
        class="js-items quick-cart__items quick-cart__recently-viewed"
      />
      <div
        v-show="tabIsMinicart"
        class="quick-cart__items"
      >
        <div
          v-if="cartIsEmpty"
          class="quick-cart__items-empty"
        >
          <p class="h4 color-fv-red">
            {{ emptyCartText }}
          </p>
        </div>
        <CartLineItem
          v-for="(item, index) in items"
          v-else
          :key="index"
          :item="item"
        />
          <a :href="buttonLink" class=" btn--continue__shopping btn btn--secondary" >
            {{ buttonText }}
          </a>
      </div>
      
      <footer
        class="quick-cart__footer"
        :class="footerClasses"
      >
        <p class="js-footer d-none" />
        <p class="js-discounts d-none" />
        <p class="js-subtotal d-none" />
        <ul
          v-if="cartHasDiscounts"
          class="mt0 quick-cart__discounts"
        >
          <li
            v-for="(discount, index) in discounts"
            :key="index"
            class="h6"
          >
            {{ discount.title }} (-{{ discount.total_allocated_amount | money }})
          </li>
        </ul>
        <p class="quick-cart__subtotal">
          {{ subtotalText }}
        </p>
        <p class="quick__cart-shipping">
          <slot name="shippingInfo" />
        </p>
        <a
          :href="cartUrl"
          class="quick-cart__checkout-button btn btn--secondary no-ajax"
        >
          {{ goToCartText }}
        </a>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { money } from 'scripts/filters/money';
import CartLineItem from './CartLineItem.vue';

export default {
  components: {
    CartLineItem,
  },

  data() {
    return {
      tabIsMinicart: true,
    }
  },
  props:{
    buttonLink:String,
    buttonText:String
  },
  computed: {
    ...mapState({
      items: (state) => state.cart.items,
      discounts: (state) => state.cart.discounts,
      cartSubtotal: (state) => state.cart.total_price,
      cartQuantity: (state) => state.cart.item_count,
    }),

    cartHasDiscounts() {
      return this.discounts && this.discounts.length > 0;
    },

    cartIsEmpty() {
      return !this.items || this.items.length === 0;
    },

    cartUrl() {
      return window.theme.routes.cart.base;
    },

    emptyCartText() {
      return window.theme.strings.cart.general.empty;
    },

    footerClasses() {
      return {
        'd-none': this.cartIsEmpty,
      };
    },

    goToCartText() {
      return window.theme.strings.layout.cart.go_to_cart;
    },

    subtotalText() {
      return window.theme.strings.cart.general.subtotal_text.replace('cart_subtotal', money(this.cartSubtotal));
    },
  },

  watch: {
    cartQuantity(quantity) {
      this.updateHeaderCounter(quantity);
    }
  },

  async created() {
    await this.getCart();

    document.addEventListener('flu:cart:item-added', this.onProductAdded);
    this.handleTabClick();
  },

  methods: {
    ...mapActions({
      getCart: 'cart/init',
    }),

    async onProductAdded() {
      await this.getCart();
    },

    handleTabClick() {
      const minicartLink = document.querySelector('.js-tab-link-cart');
      const recentlyViewedLink = document.querySelector('.js-tab-link-recent');

      if (minicartLink && recentlyViewedLink) {
        minicartLink.addEventListener('click', () => {
          this.tabIsMinicart = true;
        });
        recentlyViewedLink.addEventListener('click', () => {
          this.tabIsMinicart = false;
        });
      }
    },

    updateHeaderCounter(quantity) {
      const headerCounterWrappers = document.querySelectorAll('.js-cart-count');

      headerCounterWrappers.forEach(el => {
        const counter = el.querySelector('.quick-cart__indicator-inner');

        if (el && counter) {
          counter.innerHTML = quantity;
          el.classList.toggle('hidden', quantity === 0);
        }
      })
    },
  }
}
</script>

<style>

</style>